import React from 'react';
import { DialogProps as MuiDialogProps, styled } from '@mui/material';
import { DialogStyled } from './Dialog.styles';
import { Backdrop } from '../Backdrop';

interface DialogProps extends MuiDialogProps {
  showOverlay?: boolean;
}

const BlockingOverlay = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 1
}));

export const Dialog: React.FC<DialogProps> = ({ children, showOverlay = false, ...props }) => {
  return (
    <DialogStyled {...props}>
      {showOverlay && <BlockingOverlay open={true} showSpinner={true} />}
      {children}
    </DialogStyled>
  );
};
